export default __webpack_public_path__ + "static/media/negative-icon.3fa8f9c2.svg";